import React, { FC } from "react";
import clsx from "clsx";

import { Hope } from "../../../../state";
import { FACULTIES } from "../../../../constants/career_challenge_sheet";
import TextField from "../TextField";
import SelectField from "../SelectField";
import HopeScoreSelector from "../HopeScoreSelector";
import QuestionHeader from "../QuestionHeader";
import useFormItemEditor from "../../../../hooks/useFormItemEditor";
import { ReactComponent as IconCross } from "../../../../assets/images/Career/ChallengeSheet/icon_cross.svg";
import { ReactComponent as IconPlus } from "../../../../assets/images/Career/ChallengeSheet/icon_plus.svg";
import styles from "../ChallengeSheetsModal.module.scss";

type Props = {
  hopes: Hope[];
  setHopes: (hopes: Hope[]) => void;
};

const SheetHopes: FC<Props> = ({ hopes, setHopes }) => {
  const createHope = (set_no: number): Hope => ({
    set_no,
    destination: "",
    faculty: "",
    reason: "",
    score: 1,
  });

  const {
    updateItem: updateHope,
    addItem: addHope,
    removeItem: removeHope,
  } = useFormItemEditor<Hope>(hopes, setHopes, createHope);

  return (
    <div className={styles.content}>
      <QuestionHeader
        title={"Q4.希望の進路を書いてみましょう。"}
        note={
          "ここまでに考えたことを参考にして、具体的な進路(進学先/就職先、学部や部署)を書いてみましょう。"
        }
      />
      <div className={styles.form}>
        <div className={styles.formList}>
          {hopes.map((hope, index) => (
            <div key={hope.set_no} className={styles.formItem}>
              {hopes.length > 1 && (
                <button
                  className={styles.removeButton}
                  onClick={() => removeHope(index)}
                >
                  <IconCross />
                </button>
              )}
              <div className={styles.fieldset}>
                <p className={clsx(styles.legend, styles.colorBlue)}>
                  第{index + 1}希望
                </p>
                <TextField
                  id={`destination-${hope.set_no}`}
                  label="具体的な進路"
                  placeholder="エナジード大学文学部/コア高校英語科/花屋/家業を継ぐ"
                  value={hope.destination}
                  onChange={e =>
                    updateHope(index, { destination: e.target.value })
                  }
                />
              </div>
              <div className={styles.fieldset}>
                <SelectField
                  id={`faculty-${hope.set_no}`}
                  label={"学部（任意）"}
                  placeholder={"文学部"}
                  options={FACULTIES}
                  value={hope.faculty}
                  onChange={e => updateHope(index, { faculty: e.target.value })}
                />
              </div>
              <div className={styles.fieldset}>
                <TextField
                  id={`reason-${hope.set_no}`}
                  label="理由（任意）"
                  placeholder="まだやりたいことが決まっていないから"
                  value={hope.reason ?? ""}
                  onChange={e => updateHope(index, { reason: e.target.value })}
                />
              </div>
              <div className={styles.fieldset}>
                <HopeScoreSelector
                  name={`score-${hope.set_no}`}
                  value={hope.score}
                  onChange={e =>
                    updateHope(index, { score: Number(e.target.value) })
                  }
                />
              </div>
            </div>
          ))}
        </div>
        <button className={styles.itemAddButton} onClick={() => addHope()}>
          <IconPlus />
          項目を追加する
        </button>
      </div>
    </div>
  );
};

export default SheetHopes;
